import QrScanner from "qr-scanner";

export const STORAGE_KEY = "qrCodeScannedItems";
export const CAMERA_START_DELAY_MS = 200;
export const FILE_INPUT_TRIGGER_DELAY_MS = 150;
export const RETRY_BASE_DELAY_MS = 1000;
export const REQUEST_TIMEOUT_MS = 30000;

/** Extract the UUID/ID segment from a QR code URL. */
export const extractPairzonId = (text) => {
  const hyphenated = text.match(
    /[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}/i,
  );
  if (hyphenated) return hyphenated[0];
  const compact = text.match(/[0-9a-f]{32}/i);
  return compact ? compact[0] : null;
};

/** Decode a QR code from a File using qr-scanner */
export const decodeQrFromFile = async (file) => {
  try {
    const result = await QrScanner.scanImage(file, {
      returnDetailedScanResult: true,
    });
    return result.data;
  } catch {
    throw new Error("לא זוהה קוד QR בתמונה");
  }
};

/**
 * Strip the "51." prefix from ACCNAME to produce the CUSTNAME used in
 * the Priority CUSTOMERS endpoint.  e.g. "51.106201" → "106201"
 */
export const toCustName = (accName) =>
  accName ? accName.replace(/^51\./, "") : accName;

export const isValidEmail = (v) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v);
